module.exports = __webpack_public_path__ + "94c5379c20a8e52e2868f741de1d524c.pdf";